/** Repeat rules as the API stores them, with the presets offered on a task. */
export interface RepeatRule { every: number; unit: "day" | "week" | "month" | "year"; weekdays?: number[] }

const NAMES = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
export function repeatLabel(r: RepeatRule): string {
  if (r.weekdays?.length) {
    const s = [...r.weekdays].sort();
    if (s.join() === "1,2,3,4,5") return "Every weekday";
    return `Every ${s.map((d) => NAMES[d - 1]).join(", ")}`;
  }
  const u = r.every === 1 ? r.unit : `${r.unit}s`;
  return r.every === 1 ? `Every ${u}` : `Every ${r.every} ${u}`;
}

export const REPEAT_PRESETS: Array<[string, RepeatRule]> = [
  ["Every day", { every: 1, unit: "day" }],
  ["Every weekday", { every: 1, unit: "week", weekdays: [1, 2, 3, 4, 5] }],
  ["Every week", { every: 1, unit: "week" }],
  ["Every 2 weeks", { every: 2, unit: "week" }],
  ["Every month", { every: 1, unit: "month" }],
  ["Every 3 months", { every: 3, unit: "month" }],
  ["Every 6 months", { every: 6, unit: "month" }],
  ["Every year", { every: 1, unit: "year" }],
];
export const sameRule = (a: RepeatRule | null | undefined, b: RepeatRule | null | undefined) => JSON.stringify(a ?? null) === JSON.stringify(b ?? null);
